export const clearSpecificLocalStorage = (keysToPreserve: string[]) => {
    for (const key in localStorage) {
        if (!keysToPreserve.includes(key)) {
            localStorage.removeItem(key)
        }
    }
}
